import React from 'react';
import cx from 'clsx';
import {
  withStyles,
  TableRow as MuiTableRow
} from '@material-ui/core';

const TableRow = withStyles(theme => ({
  root: {
    height: 'auto'
  },
  autoStriped: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  borderTop: {
    borderTop: '2px #eee solid'
  },
  borderBottom: {
    borderBottom: '2px #eee solid'
  },
  borderRight: {
    borderRight: '2px #eee solid'
  },
  borderLeft: {
    borderLeft: '2px #eee solid'
  },
  striped: {
    backgroundColor: '#fafafa'
  }
}))(({
  model,
  variant,
  autoStriped = false,
  striped = false,
  colorStrip,
  border = 'none',
  className,
  classes,
  children,
  theme,
  activeName,
  onNameChange,
  sortType,
  style,
  ...props
}) => (
  <MuiTableRow
    className={cx(classes.root, {
      [classes.autoStriped]: autoStriped,
      [classes.striped]: striped,
      [classes.borderTop]: border === 'all' || border === 'top' || border.includes('top'),
      [classes.borderBottom]: border === 'all' || border === 'bottom' || border.includes('bottom'),
      [classes.borderRight]: border === 'all' || border === 'right' || border.includes('right'),
      [classes.borderLeft]: border === 'all' || border === 'left' || border.includes('left')
    }, className)}
    style={{
      backgroundColor: striped ? colorStrip || '#fafafa' : 'unset',
      ...style
    }}
    {...props}
  >
    {React.Children.toArray(children).map(child => React.cloneElement(child, { model, variant, activeName, sortType, onNameChange }))}
  </MuiTableRow>
))

export default TableRow;
